export type DalError = {
    type: "no-user-found" | "invalid-credentials" | "unknown-error" | "api-error" | "not-found" | "request-canceled";
    message?: string;
    statusCode?: number;
};

export type DalReturn<T, E extends DalError = DalError> = {
    success: true,
    data: T
} | {
    success: false,
    error: E
};

export class ThrowableDalError extends Error {
    dalError: DalError;
    constructor(dalError: DalError) {
        super();
        this.dalError = dalError;
    }
};

export const createSuccessReturn = <T>(data: T): DalReturn<T, never> => ({ success: true, data });

export const createErrorReturn = <E extends DalError>(dalError: E): DalReturn<never, E> => ({ success: false, error: dalError });
